import { TabsContent } from '@/components/ui/tabs';
import FormA, { FormAData } from '../FormA';
import FormK from '../FormK';
import IdentificationForm from '../IdentificationForm';
import { IdentificationFormData } from '../identification';
import { FormKData } from '../types/formK.types';
import { FormValidationRef, KycFormData } from '../types/kycFormTabs.types';

interface KycTabContentProps {
  formData: KycFormData;
  identificationFormRef: React.RefObject<FormValidationRef | null>;
  formKRef: React.RefObject<FormValidationRef | null>;
  formARef: React.RefObject<FormValidationRef | null>;
  onIdentificationSubmit: (data: IdentificationFormData) => void;
  onIdentificationError: (error: Error) => void;
  onIdentificationChange: (data: Partial<IdentificationFormData>) => void;
  onFormKSubmit: (data: FormKData) => void;
  onFormKError: (error: Error) => void;
  onFormKChange: (data: Partial<FormKData>) => void;
  onFormASubmit: (data: FormAData) => void;
  onFormAError: (error: Error) => void;
  onFormAChange: (data: Partial<FormAData>) => void;
}

/**
 * Component for rendering KYC form tab content panels.
 * Displays the appropriate form based on the active tab.
 *
 * @param {KycTabContentProps} props - Component properties including form refs and handlers
 * @returns {JSX.Element} Tab content panels for Identification, Form K, and Form A
 */
export function KycTabContent({
  formData,
  identificationFormRef,
  formKRef,
  formARef,
  onIdentificationSubmit,
  onIdentificationError,
  onIdentificationChange,
  onFormKSubmit,
  onFormKError,
  onFormKChange,
  onFormASubmit,
  onFormAError,
  onFormAChange,
}: KycTabContentProps) {
  return (
    <>
      <TabsContent value='identification' className='mt-6'>
        <div className='space-y-4'>
          <IdentificationForm
            ref={identificationFormRef}
            onSubmit={onIdentificationSubmit}
            onError={onIdentificationError}
            defaultValues={formData.identification}
            onChange={onIdentificationChange}
          />
        </div>
      </TabsContent>

      <TabsContent value='form-k' className='mt-6'>
        <FormK
          ref={formKRef}
          onSubmit={onFormKSubmit}
          onError={onFormKError}
          defaultValues={formData.formK}
          onChange={onFormKChange}
        />
      </TabsContent>

      <TabsContent value='form-a' className='mt-6'>
        <FormA
          ref={formARef}
          onSubmit={onFormASubmit}
          onError={onFormAError}
          defaultValues={formData.formA}
          onChange={onFormAChange}
        />
      </TabsContent>
    </>
  );
}
